export default __webpack_public_path__ + "/images/clock-and-envelope.svg";